// extracted by mini-css-extract-plugin
export default {"dialogContent":"style--dialogContent--741b84","tabContent":"style--tabContent--36c7f5"};